import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { getlangV2, setlang } from 'src/helper/getlang'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import langM from './lang'

@inject('store')
@observer
export default class extends React.Component {
  constructor(props) {
    super(props)
  }
  state = {
    lang: langM.en,
    language: "en",
  }

  async closeWebview() {
    closeWebview()
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language =await getlangV2(language, langM)
    console.log("language", language)
    this.setState({
      lang: setlang(language, langM),
      language: language,
    })
    let uid = await setUidToken(this.props.location.query)
    await this.RunOnStart(uid)
  }

  async RunOnStart(uid) {
  }

  render() {
    let { language, lang } = this.state
    return (
      <div className="page-lottery">
        <div className='title-div'>
          <div className={`box-rule-title ${language == 'ar' && 'arlang'}`}>
            <h3 style={{margin:'0 auto'}}>{lang.title}</h3>
            {/* <div className='top_right_box'>
          <div onClick={() => this.closeWebview()}><img src="/img/activity/fruitgame/icon-close.png"></img></div>
          </div> */}
          </div>
        </div>

        <div className='box-rule-content'>
          <div className={`content  ${language == 'ar' && 'arlang arlangs'}`} dangerouslySetInnerHTML={{ __html: lang.content }}></div>
        </div>
        {/* <div className='box-footer'><div onClick={() => this.closeWebview()} className='box-div'>
            ok
          </div></div>    */}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/mine/index.js